// @flow
import generalIcons from '~/core/constants/icons/general-svg';
import styled from 'styled-components';
import SVGIcon from '~/core/icons/svg-icons';

export const HtmlLink = styled.a`
    align-items: center;
    color: ${props => props.theme.primaryFontColor};
    display: flex;
    margin: 1em;
    text-decoration: none;
`;

export const PhoneIcon = styled(SVGIcon).attrs({ type: generalIcons.CALL })`
    height: 2.5em;
    width: 2.5em;

    & g {
        fill: ${props => props.theme.mainBrandColor};
    }
`;

export const Text = styled.span`font-size: 1.6em;`;



// WEBPACK FOOTER //
// ./src/components/widgets/phone-number/styles.js